import { ImageSize } from "@app/models/enums"

export function getContactImage(contactId: string, size: number): string {
  return `/api/Contacts/${contactId}/ProfileImage${getSizeQuery(size)}`
}

export function getDefaultImageUrl(isCompany: boolean, size: number): string {
  const defaultImageSize = getSizeQuery(size).replace(/[\?=&]/g, '_')

  return isCompany
    ? `/images/default-company${defaultImageSize}.png`
    : `/images/default-profile${defaultImageSize}.png`
}

export function getImageSize(size: number): ImageSize {
  if (size <= 50) {
    return ImageSize.h50w50
  } else if (size <= 250) {
    return ImageSize.h100w100
  } else {
    return ImageSize.h500w500
  }
}

export function getSizeQuery(size: number): string {
  if (size <= 50) {
    return '?h=50&w=50'
  } else if (size <= 250) {
    return '?h=100&w=100'
  } else {
    return '?h=500&w=500'
  }
}
